export const splunkEventsData = {
    emailNotAssociatedError: 'forgot-password-email-not-associated-error',
};
